<template>
  <div class="my-trip-panel">
    <div class="my-trip">
      <GmapMap ref="map" :center="this.$store.state.maps.centerPoint" />
      <div id="map"></div>
      <div class="edit-my-trip">Edit My Trip</div>
      <div class="trip-name">{{ tripName }}</div>
      <div class="trip-name-label">Trip Name</div>
      <!-- Trip Name -->
      <input
        @click="handleName"
        id="trip-name"
        autocomplete="off"
        type="text"
        v-model="tripName"
        placeholder="Trip Name"
        class="input-container trip-name-input"
        :aria-invalid="invalidName" />
      <div class="help-error" aria-live="polite">
        <span>{{ this.nameMessage }}</span>
      </div>
      <!-- Starting Point -->
      <div class="starting-point-label">Starting Point</div>
      <input
        @click="handleStartPoint"
        @blur="handleInputBlur"
        id="starting"
        autocomplete="off"
        type="text"
        placeholder="Starting Point"
        v-model="startingPoint"
        class="input-container start"
        :aria-invalid="invalidStart" />
      <div class="help-error" aria-live="polite">
        <span>{{ this.startMessage }}</span>
      </div>
      <!-- Destination Point -->
      <div class="destination-label">Destination</div>
      <input
        @click="handleDestination"
        @blur="handleInputBlur"
        id="destination"
        autocomplete="off"
        type="text"
        placeholder="Destination"
        v-model="destination"
        class="input-container destination"
        :aria-invalid="invalidDestination" />
      <div class="help-error" aria-live="polite">
        <span>{{ this.destinationMessage }}</span>
      </div>
      <button @click="saveTrip" :disabled="disableSubmitBtn" class="save-trip-btn">
        <div class="save-trip-text">Save Trip</div>
      </button>
      <div @click="cancelChanges" class="cancel-changes">Cancel Changes</div>
      <!-- Delete Trip -->
      <div class="delete-trip-label">Delete Trip</div>
      <div class="delete-trip-tx">This will delete the {{this.tripName}}. This cannot be undone.</div>
      <button v-b-modal.delete-trip-modal :disabled="disableSubmitBtn" class="delete-trip-btn">
        <div class="delete-trip-text">Delete Trip</div>
      </button>
      <b-modal id="delete-trip-modal" size="sm" button-size="lg" centered hide-header hide-footer hide-backdrop>
        <div class="delete-trip-modal">
          <p class="delete-trip-modal-title">Confirmation</p>
          <span class="delete-trip-modal-message">Are you sure you want to delete the {{ this.tripName }}?</span>
          <hr />
          <div class="confirm-delete">
            <div @click="$bvModal.hide('delete-trip-modal')" class="cancel-tx">Cancel</div>
            <div class="spacer"></div>
            <div @click="deleteTrip" class="delete-tx">Delete Trip</div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';


export default {
  props: {
    tripInfo: {
      type: Object,
    },
  },
  data() {
    return {
      endPoint: '',
      startPoint: '',
      owner: this.$props.tripInfo.owner,
      tripName: this.$props.tripInfo.name,
      tripLocations: this.$props.tripInfo.locations,
      routing: {
        begin: {
          lat: this.$props.tripInfo.routing.begin.lat,
          long: this.$props.tripInfo.routing.begin.long,
          city: this.$props.tripInfo.routing.begin.city,
          state: this.$props.tripInfo.routing.begin.state,
        },
        end: {
          lat: this.$props.tripInfo.routing.end.lat,
          long: this.$props.tripInfo.routing.end.long,
          city: this.$props.tripInfo.routing.end.city,
          state: this.$props.tripInfo.routing.end.state,
        },
      },
      invalidStart: false,
      invalidDestination: false,
      invalidName: false,
      showMobileMenu: false,
      startHelp: false,
      destinationHelp: false,
      nameHelp: false,
      nameMessage: '',
      destinationMessage: '',
      startMessage: '',
      disableSubmitBtn: false,
      destinationLatLong: '',
      tripId: '',
    };
  },
  created() {
    this.tripId = this.$route.path.replace('/trip/', '');
  },
  computed: {
    ...mapGetters({
      hasTrips: 'myTrips/hasTrips',
      myTrips: 'myTrips/myTrips',
      myTripsLoaded: 'myTrips/loaded',
      getTripById: 'myTrips/getTripById',
    }),
    startingPoint: {
      get() {
        return `${this.routing.begin.city}, ${this.routing.begin.state}, USA`;
      },
      set() {
        return `${document.getElementById('starting').value.split(',')[0]}, ${document.getElementById('starting').value.split(',')[1]}, USA`;
      },
    },
    destination: {
      get() {
        return `${this.routing.end.city}, ${this.routing.end.state}, USA`;
      },
      set() {
        return `${document.getElementById('destination').value.split(',')[0]}, ${document.getElementById('destination').value.split(',')[1]}, USA`;
      },
    },
  },
  methods: {
    ...mapActions({
      loadMyTrips: 'myTrips/loadMyTrips',
      editTrip: 'myTrips/editTrip',
      deleteTripFromState: 'myTrips/deleteTrip',
    }),
    handleInputBlur() {
      setTimeout(() => {
        const [startCity, startState] = document.getElementById('starting').value.split(', ');
        this.routing.begin.city = startCity;
        this.routing.begin.state = startState;

        const [endCity, endState] = document.getElementById('destination').value.split(', ');
        this.routing.end.city = endCity;
        this.routing.end.state = endState;
      }, 500);
    },
    handleStartPoint() {
      this.startMessage = 'We will need to know where you are starting from?';
      this.startHelp = true;
    },
    handleDestination() {
      this.destinationMessage = 'Where are you headed?';
      this.destinationHelp = true;
    },
    handleName() {
      this.nameMessage = 'Please enter the name of your trip.';
      this.nameHelp = true;
    },
    showValidationError(field, message) {
      this.nameHelp = field === 'name';
      this.invalidName = field === 'name';
      this.startHelp = field === 'start';
      this.invalidStart = field === 'start';
      this.destinationHelp = field === 'destination';
      this.invalidDestination = field === 'destination';

      this.nameMessage = field === 'name' ? message : '';
      this.startMessage = field === 'start' ? message : '';
      this.destinationMessage = field === 'destination' ? message : '';
    },
    validateForm() {
      if (this.tripName === '') {
        this.showValidationError('name', 'You must enter a trip name');
        return;
      }

      if (document.getElementById('starting').value === '') {
        this.showValidationError('start', 'Please enter a starting point');
        return;
      }

      if (document.getElementById('destination').value === '') {
        this.showValidationError('destination', 'Please enter a destination');
        return;
      }

      this.disableSubmitBtn = false;
    },
    async saveTrip() {
      try {
        this.disableSubmitBtn = true;
        this.endPoint = document.getElementById('destination').value;
        this.startPoint = document.getElementById('starting').value;
        await this.validateForm();

        const tripInfo = await this.getTripById(this.tripId).tripInfo;

        const trip = {
          owner: this.owner,
          tripId: this.tripId,
          name: this.tripName,
          locations: this.tripLocations,
          routing: {
            begin: {
              lat: this.routing.begin.lat,
              long: this.routing.begin.long,
              city: this.startPoint.includes(',') ? this.startPoint.split(',')[0] : this.routing.begin.city,
              state: this.startPoint.includes(',') ? this.startPoint.split(', ')[1] : this.routing.begin.state,
            },
            end: {
              lat: this.routing.end.lat,
              long: this.routing.end.long,
              city: this.endPoint.includes(',') ? this.endPoint.split(',')[0] : this.routing.end.city,
              state: this.endPoint.includes(',') ? this.endPoint.split(', ')[1] : this.routing.end.state,
            },
          },
          tripInfo,
        };
        const userId = this.owner.replace(/-/g, '');
        await this.editTrip(trip);
        await this.$router.push(`/my-trip/${userId}`);
        setTimeout(() => {
          this.$bvToast.toast('Trip saved.', {
            title: 'Trip saved!',
            autoHideDelay: 3000,
            appendToast: this.append,
          });
        }, 500);
      } catch (e) {
        throw e;
      }
    },
    async cancelChanges() {
      // eslint-disable-next-line
      location.reload();
    },
    async deleteTrip() {
      const userId = this.owner.replace(/-/g, '');
      await this.deleteTripFromState(this.tripInfo);
      await this.$router.push({ name: 'mytrip-list', params: { id: userId } });
      setTimeout(() => {
        this.$bvToast.toast('Trip deleted.', {
          title: 'Trip deleted!',
          autoHideDelay: 3000,
          appendToast: this.append,
        });
      }, 500);
    },
    updatePlaces() {
      const us = { country: ['us'] };
      const southwest = { lat: 30.67, lng: -88.1 };
      const northeast = { lat: 34.95, lng: -85.72 };
      // eslint-disable-next-line
      const newBounds = new google.maps.LatLngBounds(southwest, northeast);

      const configureAutocomplete = (input, onPlaceChanged) => {
        // eslint-disable-next-line
        const autocomplete = new google.maps.places.Autocomplete(input, { types: ["geocode"] });
        autocomplete.setComponentRestrictions(us);
        autocomplete.setBounds(newBounds);
        autocomplete.setOptions({ strictBounds: true });
        autocomplete.setFields(['address_component', 'geometry']);
        autocomplete.addListener('place_changed', onPlaceChanged);
        return autocomplete;
      };

      const destination = document.getElementById('destination');
      const starting = document.getElementById('starting');

      const destAutocomplete = configureAutocomplete(destination, () => {
        const place = destAutocomplete.getPlace();
        this.routing.end.lat = place.geometry.location.lat();
        this.routing.end.long = place.geometry.location.lng();
      });

      const startingAutocomplete = configureAutocomplete(starting, () => {
        const place = startingAutocomplete.getPlace();
        this.routing.begin.lat = place.geometry.location.lat();
        this.routing.begin.long = place.geometry.location.lng();
      });
    },
  },
  mounted() {
    this.updatePlaces();
  },
};
</script>

<style>
/* Override bootstrap modal backdrop and content classes */
div>div.modal {
  background-color: #fff;
  opacity: 0.95;
}

div>div.modal .modal-content {
  width: 370px;
  margin: 0 auto;
  border: none;
  padding: 5px;
  padding-bottom: 0;
  border-radius: 14px;
  /* background-color: rgba(242, 242, 242, 0.95); */
  opacity: 1;
}
</style>

<style scoped>
  .my-trip {
    margin: 0 auto;
    width: 325px;
    text-align: center;
    z-index: 10;
  }
  .edit-my-trip {
    height: 12px;
    margin-left: 0;
    margin-bottom: 5px;
    margin-top: 100px;
    font-family: "KlinicSlabmedium";
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--dark-blue-300);
    text-align: left;
  }
  .trip-name {
    width: 300px;
    font-family: "KlinicSlabmedium";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6daab2;
    text-align: left;
    margin-bottom: 50px;
  }
  .trip-name-label, .starting-point-label, .destination-label {
    width: 300px;
    margin-left: 10px;
    margin-bottom: 9px;
    text-align: left;
    font-family: "KlinicSlabmedium";
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--dark-blue-300);
  }
  .add-starting-point-tx {
    margin-top: 25px;
  }
  .input-container {
    width: 320px;
    height: 50px;
    padding: 18px 12px;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #fff;
    color: black;
    z-index: 10;
  }
  .input-container::placeholder {
    color: black;
    opacity: 1;
  }
  .trip-name-input, .destination, .start {
    font-family: "IdealSans-Medium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    color: #000;
    margin-left: 0;
  }
  .help-error {
    width: 300px;
    height: 12px;
    margin: 5px auto 25px;
    font-family: "IdealSans-Medium";
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.33px;
    text-align: left;
    color: #000;
  }
  input#start ~ div.help-error {
    margin-bottom: 10px;
  }
  .locations {
    display: flex;
    justify-content: center;
    z-index: 10;
  }
  .locations-list {
    position: relative;
    top: -47px;
    left: -19px;
    margin-bottom: 0;
    width: 345px;
    z-index: 10;
    border-radius: 25px;
  }
  .locations-items {
    list-style: none;
    text-align: left;
    padding-left: 5px;
    font-size: 14px;
    color: #fff;
    background-color: #173945;
    cursor: pointer;
  }
  .locations-items:hover {
    color: #979797;
  }
  .save-trip-btn {
    width: 155px;
    height: 36px;
    padding: 5px 0 ;
    border-radius: 8px;
    font-size: 10px;
    font-family: "KlinicSlabmedium";
    border: solid 1px #979797;
    background-color: #173945;
    cursor: pointer;
    margin-top: 40px;
  }
   .save-trip-btn:focus {
    outline: 2.75px dotted !important;
    outline-color: #4c8ea0 !important;
    outline-offset: 3px !important;
  }
  .save-trip-btn:hover {
    box-shadow: 0 2px 27px 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .save-trip-text {
    width: 160px;
    height: 18px;
    font-family: "IdealSans-Medium";
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: center;
    color: #f7f6f1;
    margin: 0 auto;
    margin-left: -2px;
  }
  .cancel-changes {
    margin-top: 21px;
    font-family: "IdealSans-Medium";
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #003049;
    cursor: pointer;
  }
  .delete-trip-label {
    margin-top: 41px;
    font-family: "IdealSans-Medium";
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #003049;
  }
  .delete-trip-tx {
    width: 275px;
    margin-top: 7px;
    font-family: "IdealSans-Medium";
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    color: #000;
  }
  .delete-trip-btn {
    width: 300px;
    height: 61px;
    padding: 22px auto;
    border-radius: 8px;
    font-size: 18px;
    font-family: "IdealSans-Medium";
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: center;
    border: solid 1px #c60000;
    background-color: #fff;
    cursor: pointer;
    color: #c60000;
    margin-top: 17px;
    margin-bottom: 30px;
  }
   .delete-trip-btn:focus {
    outline: 2.75px dotted !important;
    outline-color: #c60000 !important;
    outline-offset: 3px !important;
  }
  .delete-trip-btn:hover {
    box-shadow: 0 1px 1px 0 rgba(198, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .delete-trip-modal {
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 8px;
    margin: 0 auto;
    padding: 12px;
    text-align: center;
    opacity: 1;
  }
  .delete-trip-modal-title, .delete-trip-modal-message {
    font-family: 'IdealSans-Semibold';
    font-size: 17px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    margin-bottom: 0;
  }
  .delete-trip-modal-message {
    width: 238px;
    font-family: 'IdealSans-Book';
    font-weight: normal;
    font-size: 13px;
  }
  .confirm-delete {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    cursor: pointer;
  }
  .cancel-tx, .delete-tx {
    font-family: 'IdealSans-Medium';
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    color: #173945;
  }
  .cancel-tx {
    margin-right: 5px;
  }
  .delete-tx {
    margin-left: 5px;
  }
  .spacer {
    width: 20px;
  }
  input {
    margin: 0px 0 10px 0px;
    padding: 15px;
    min-width: 270px;
  }
  label {
    margin-bottom: 0px;
    font-size:14px;
  }
  button {
    cursor: pointer;
  }
  .my-trip-panel {
    width: 50%;
  }
  @media only screen and (max-width: 769px) {
    .locations-items {
      left: 7px;
    }
    .edit-my-trip {
      margin-top: 25px;
    }
    .my-trip-panel {
    width: 100%;
    }
  }
</style>
